import { TransactionType } from '../../entities/TransactionType/TransactionType';
import { TransactionTypeResponseDTO } from '../../entities/TransactionType/TransactionTypeResponseDTO';

const TransactionTypeResponseDTOtoTransactionTypeAdapter = (
  response: TransactionTypeResponseDTO,
): TransactionType[] => {
  if (!response.body) {
    throw Error();
  }

  return response.body.types.map(({ id, description }) => new TransactionType(id, description));
};

export { TransactionTypeResponseDTOtoTransactionTypeAdapter };
